/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingApplicationStatus {
    DRAFT = 'Draft',
    NEW = 'New',
    IN_REVIEW = 'InReview',
    WAITLIST = 'Waitlist',
    ON_HOLD = 'OnHold',
    CANCELLED = 'Cancelled',
    LOCKED_INTERVIEWING = 'LockedInterviewing',
    OFFER_ACCEPTED = 'OfferAccepted',
    HOUSED = 'Housed',
    SUBMITTED = 'Submitted',
    ASSIGNED = 'Assigned',
    PRSCOMPLETED = 'PRSCompleted',
    INTAKE = 'Intake',
    OFFER_ACTIVE = 'OfferActive',
    LOCKED_WITH_OFFER = 'LockedWithOffer',
    WAITLISTED = 'Waitlisted',
    OFFER_REJECTED = 'OfferRejected',
    CANCELED = 'Canceled',
}
